<template>
  <div>
    <AppLayout title="Lojas">
      <template #actions>
        <button type="button" @click="show_newStore()" class="btn btn-primary">Nova Loja</button>
      </template>

      <div class="table-card">
        <table class="table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Endereço</th>
              <th>Status</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="loja in lista_lojas" :key="loja.id">
              <td>{{ loja.name }} <span v-if="loja.is_default" class="badge text-bg-secondary">Padrão</span></td>
              <td>{{ loja.address ?? '' }}</td>
              <td>
                <span class="badge" :class="loja.active ? 'text-bg-success' : 'text-bg-secondary'">
                  {{ loja.active ? 'Ativa' : 'Inativa' }}
                </span>
              </td>
              <td style="width:50px"><button @click="show_editStore(loja)" type="button" class="btn btn-primary btn-sm"><i class="bi bi-pencil-square"></i></button></td>
              <td style="width:50px"></td>
              <td style="width:50px"><button @click="show_deleteStore(loja)" type="button" class="btn btn-danger btn-sm"><i class="bi bi-trash-fill"></i></button></td>
            </tr>
            <tr v-if="!lista_lojas.length">
              <td colspan="6" class="text-center text-muted">Nenhuma loja cadastrada.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </AppLayout>

    <!-- Modal Loja -->
    <div class="modal fade" id="modal_loja" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div v-if="edit"><h5 class="modal-title">Editar Loja</h5></div>
            <div v-else><h5 class="modal-title">Nova Loja</h5></div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form id="form-loja">
              <div class="mb-3">
                <label for="inp_name" class="form-label">Nome:</label>
                <input v-model="loja.name" type="text" class="form-control" name="inp_name" id="inp_name">
              </div>
              <div class="mb-3">
                <label for="inp_address" class="form-label">Endereço:</label>
                <input v-model="loja.address" type="text" class="form-control" name="inp_address" id="inp_address">
              </div>
              <div class="form-check" v-if="edit">
                <input v-model="loja.active" class="form-check-input" type="checkbox" id="inp_active">
                <label class="form-check-label" for="inp_active">Loja ativa</label>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button type="submit" @click="actionStore()" class="btn btn-primary">Salvar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Deletar -->
    <div class="modal fade" id="modal_deletar" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Excluir loja?</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ loja.name }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button @click="deleteStore()" class="btn btn-danger">Excluir</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Feedback -->
    <div class="modal fade" id="modal_feedback" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ feedback_error ? 'Não foi possível concluir' : 'Sucesso' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ msn_feedback }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, ref } from 'vue';
import { Modal } from "bootstrap";
import AppLayout from "@/components/AppLayout.vue";
import { lojas } from "@/models/lojas";

export default {
  name: 'StoresView',
  components: { AppLayout },
  setup() {
    const Lojas = lojas();
    const lista_lojas = ref([]);

    const edit = ref(false);
    const msn_feedback = ref('');
    const feedback_error = ref(false);

    let modal = '';

    const loja = reactive({
      id: '',
      name: '',
      address: '',
      active: true,
    });

    function openModal(elemento) {
      modal = new Modal(document.getElementById(elemento));
      modal.show();
    }

    function closeModal() {
      modal.hide();
    }

    function limparDados() {
      loja.id = '';
      loja.name = '';
      loja.address = '';
      loja.active = true;
    }

    const show_newStore = () => {
      limparDados();
      edit.value = false;
      openModal('modal_loja');
    }

    const show_editStore = (item) => {
      edit.value = true;
      loja.id = item.id;
      loja.name = item.name;
      loja.address = item.address;
      loja.active = item.active;
      openModal('modal_loja');
    }

    const show_deleteStore = (item) => {
      loja.id = item.id;
      loja.name = item.name;
      openModal('modal_deletar');
    }

    const listStores = async () => {
      lista_lojas.value = await Lojas.list();
    }

    const saveStore = async () => {
      feedback_error.value = false;
      const result = await Lojas.createItem(loja);
      if (result === true) {
        closeModal();
        msn_feedback.value = 'Loja cadastrada com sucesso!';
        openModal('modal_feedback');
        limparDados();
        listStores();
      } else {
        closeModal();
        feedback_error.value = true;
        msn_feedback.value = result;
        openModal('modal_feedback');
      }
    }

    const updateStore = async () => {
      feedback_error.value = false;
      if (await Lojas.updateItem(loja)) {
        closeModal();
        msn_feedback.value = 'Loja atualizada com sucesso!';
        openModal('modal_feedback');
        listStores();
      } else {
        feedback_error.value = true;
        msn_feedback.value = 'Não foi possível atualizar a loja.';
        openModal('modal_feedback');
      }
    }

    const actionStore = () => {
      if (edit.value) {
        updateStore();
      } else {
        saveStore();
      }
    }

    const deleteStore = async () => {
      feedback_error.value = false;
      if (await Lojas.deleteItem(loja.id)) {
        closeModal();
        msn_feedback.value = 'Loja excluída com sucesso!';
        openModal('modal_feedback');
        listStores();
      } else {
        closeModal();
        feedback_error.value = true;
        msn_feedback.value = 'Não é possível excluir esta loja (pode ser a única, ou ter operadores/estoque vinculados).';
        openModal('modal_feedback');
      }
    }

    onMounted(function () {
      listStores();
    });

    return {
      lista_lojas, loja, edit, msn_feedback, feedback_error,
      show_newStore, show_editStore, show_deleteStore,
      actionStore, deleteStore,
    }
  },
}
</script>
